'use strict'

// Initial state
const state = {
	currentUser: null,
	entryUrl: null,
	activeProject: null,
	lastOrder: null,
	navBarExpanded: true,
	lang: 'en',

	// Checkout module
	checkoutActiveTab: 'tab-report-options',
	addedProducts: [],
	productsList: [],

	dialog: {
		info: {
			show: false,
			text: ''
		}
	}
}

export default state



// WEBPACK FOOTER //
// ./src/common/store/state.js